import { cn } from 'helpers/cn';
import './ai-chat.css';

/** How much is left: low turns amber, empty red. */
export type ChatMeterLevel = 'normal' | 'low' | 'empty';

/** What a credit meter needs to draw: the fill, its level, and the line beside it. */
export type ChatMeter = {
  /** The fill, 0 to 100: credits left against the allotment. */
  percent: number;
  level: ChatMeterLevel;
  /** "620 of 1,000 credits left". */
  line: string;
};

const LEVEL_CLASS: Record<ChatMeterLevel, string | undefined> = { normal: undefined, low: 'is-low', empty: 'is-empty' };

type MeterTrackProps = { meter: Pick<ChatMeter, 'percent' | 'level'>; className?: string };

/** The track and its fill, credits left against the allotment. Decorative: the label says it. */
export const MeterTrack = ({ meter, className }: MeterTrackProps) => (
  <span aria-hidden="true" className={cn('ai-credit-meter__track', LEVEL_CLASS[meter.level], className)}>
    <span style={{ width: `${meter.percent}%` }} />
  </span>
);
